import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import * as utils from '../../utils/utility-functions';
import { Expert } from "src/app/models/expert.model";
import * as moment from "moment-timezone";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import { AngularFireFunctions } from "@angular/fire/compat/functions";


@Injectable({
  providedIn: 'root',
})

export class ExpertService {
  private firebaseExpertCollection: AngularFirestoreCollection;
  private firebaseExpertAvailabilityCollection: AngularFirestoreCollection;

  private currentUser: any;

  private expert = new BehaviorSubject(new Expert);
  currentExpert = this.expert.asObservable();

  constructor(
    private angularFirestore: AngularFirestore,
    private angularFunctions: AngularFireFunctions
  ) {
    const expertUser = localStorage.getItem('expertUser');
    this.expert.next(JSON.parse(expertUser));
  }

  async getExpert() {
    try {
      let expert = null;

      if (this.firebaseExpertCollection == null) {
        this.firebaseExpertCollection = this.angularFirestore.collection('Experts');
      }

      await this.firebaseExpertCollection.ref
        .doc(this.currentUser.id)
        .get()
        .then(querySnapshot => {
          const docData = {
            id: querySnapshot.id,
            ...querySnapshot.data()
          }
          expert = docData;
        }).catch(err => console.log("getExpert query 1 error: " + err));

      this.updateExpertUser(expert);
      return expert;
    } catch (error) {
      console.log('getExpertByID(): ' + JSON.stringify(error));
    }
  }

  async getExpertByUserID(id: string) {
    try {
      let expert = null;

      if (this.firebaseExpertCollection == null) {
        this.firebaseExpertCollection = this.angularFirestore.collection('Experts');
      }

      await this.firebaseExpertCollection.ref
        .doc(id)
        .get()
        .then(querySnapshot => {
          const docData = {
            id: querySnapshot.id,
            ...querySnapshot.data()
          }
          expert = docData;
        }).catch(err => console.log("getExpertByUserID query 1 error: " + err));

      this.updateProfileUser(expert);
      return expert;
    } catch (error) {
      console.log(error);
    }
  }

  async getExpertInformation(userID: string) {
    try {
      let expert = null;

      if (this.firebaseExpertCollection == null) {
        this.firebaseExpertCollection = this.angularFirestore.collection('Experts');
      }

      await this.firebaseExpertCollection.ref
        .doc(userID)
        .get()
        .then(querySnapshot => {
          const docData = {
            id: querySnapshot.id,
            ...querySnapshot.data()
          }
          expert = docData;
        }).catch(err => console.log("getExpertInformation query 1 error: " + err));

      this.updateExpertUser(expert);
      return expert;
    } catch (error) {
      console.log('getExpertInformation(): ' + JSON.stringify(error));
    }
  }

  updateProfileUser(userProfile: any) {
    const updatedProfile = utils.createExpert(userProfile);
    this.expert.next(updatedProfile);
  }

  updateExpertUser(expert: any) {
    const expertUser = utils.createNewExpertObject(expert);
    localStorage.setItem('expertUser', JSON.stringify(expertUser));

    let newExpert: Expert = utils.createExpert(expert);
    this.expert.next(newExpert);
  }

  async createZoomMeeting(appointment: any) {
    try {
      const callable = this.angularFunctions.httpsCallable('createZoomMeeting');

      return callable({
        appointment: appointment
      })
        .toPromise()
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return null;
        }
        );
    } catch (error) {
      console.log('createZoomMeeting(): ' + JSON.stringify(error));
    }
  }

  async getDaySchedule(timeDate: any) {
    try {
      let availabilitySchedule: any[] = [];

      if (this.firebaseExpertAvailabilityCollection == null) {
        this.firebaseExpertAvailabilityCollection = this.angularFirestore.collection('ExpertAvailability');
      }

      let useTime = moment(timeDate).year(moment().year()).format();

      const expertID = this.expert.value.id;

      let startDateTemp = moment(useTime).startOf("day").format('x');
      let endDateTemp = moment(useTime).endOf("day").format('x');

      await this.firebaseExpertAvailabilityCollection.ref
        .where('expert_id', '==', expertID)
        .where('timestamp', '>=', startDateTemp)
        .where('timestamp', '<=', endDateTemp)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const docData = {
              id: doc.id,
              ...doc.data()
            }
            availabilitySchedule.push(docData)
          });
        }).catch(err => console.log("getDaySchedule query 1 error: " + err));

      // Get and return times
      const getTimes = this.sortDay(availabilitySchedule);
      return getTimes;
    } catch (error) {
      console.log('getDaySchedule(): ' + JSON.stringify(error));
    }
  }

  async updateExpertAvailability(time: any) {
    try {
      if (this.firebaseExpertAvailabilityCollection == null) {
        this.firebaseExpertAvailabilityCollection = this.angularFirestore.collection('ExpertAvailability');
      }

      await this.firebaseExpertAvailabilityCollection.ref
        .doc(time.id)
        .update({
          available: false,
          booked: true,
        }).catch(err => console.log("updateExpertAvailability update 1 error: " + err));
    } catch (error) {
      console.log('updateExpertAvailabilityAsync(): ' + JSON.stringify(error));
    }
  }

  private async getSingleExpertByIdAsync(expertID: string) {
    try {
      let expert = null;

      if (this.firebaseExpertCollection == null) {
        this.firebaseExpertCollection = this.angularFirestore.collection('Experts');
      }

      await this.firebaseExpertCollection.ref
        .doc(expertID)
        .get()
        .then(querySnapshot => {
          const docData = {
            id: querySnapshot.id,
            ...querySnapshot.data()
          }
          expert = docData;
        }).catch(err => console.log("getSingleExpertByIdAsync query 1 error: " + err));

      this.updateSingleExpert(expert);
      return expert;
    } catch (error) {
      console.log(error);
    }
  }

  private sortDay(weekData: any) {
    let times = [];

    weekData.sort((a, b) => {
      return a.timestamp - b.timestamp;
    });

    weekData.forEach(element => {
      let tempTime = {
        id: element.id,
        date_time: element.date_time,
        available: element.available,
        expert_id: element.expert_id,
        timestamp: element.timestamp,
        booked: element.booked
      };

      times.push(tempTime);
    });

    return times;
  }

  updateSingleExpert(expert: any) {
    if (typeof expert !== 'undefined') {
      let newExpert = utils.createExpert(expert);
      this.expert.next(newExpert);
      localStorage.setItem("expert", JSON.stringify(newExpert));
    }
  }

  setUser(currentUser: any) {
    this.currentUser = currentUser;
    this.getExpert();
  }

  getSingleExpertById(expertID: string) {
    this.getSingleExpertByIdAsync(expertID);
  }
}